/**
 * One Column Content Block JavaScript
 *
 * @package TekCreative
 * @since 2.0.0
 */

(function() {
    'use strict';

    const OneColContent001 = {
        selector: '.one-col-content-001',

        init() {
            const blocks = document.querySelectorAll(this.selector);
            if (!blocks.length) return;

            blocks.forEach(block => this.initBlock(block));
        },

        initBlock(block) {
            const emElements = block.querySelectorAll('.one-col-content-001__content em');
            if (!emElements.length) return;

            emElements.forEach(em => this.processEm(em));
        },

        processEm(em) {
            // Save original markup on first run, so this stays idempotent if
            // the block preview re-triggers init (editor/resize/etc).
            if (!em.dataset.originalHtml) {
                em.dataset.originalHtml = em.innerHTML.trim();
            }

            const originalHtml = em.dataset.originalHtml;
            if (!originalHtml) return;

            // Lines are whatever the editor explicitly broke with <br> - no
            // width measurement needed, each chunk between <br>s is a line.
            const lines = originalHtml
                .split(/<br\s*\/?>/i)
                .map(line => line.trim())
                .filter(Boolean);

            if (!lines.length) return;

            // Each line is a full-width block (see .one-col-content-001__line
            // in the stylesheet) whose decoration is a CSS background
            // (::before, bg-decoration) instead of an inline SVG.
            em.innerHTML = lines.map(lineHtml =>
                `<span class="one-col-content-001__line"><span class="one-col-content-001__line-text">${lineHtml}</span></span>`
            ).join('');
        },
    };

    // Initialize on DOM ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => OneColContent001.init());
    } else {
        OneColContent001.init();
    }

    // Re-initialize for Gutenberg editor preview
    if (window.acf) {
        window.acf.addAction('render_block_preview/type=one-col-content-001', () => {
            setTimeout(() => OneColContent001.init(), 100);
        });
    }

})();
